import React from 'react';

function AnchorIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="21"
      viewBox="0 0 21 21"
    >
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g fill="#FFF" fillRule="nonzero" transform="translate(-961 -1344)">
          <g transform="translate(926 1175)">
            <path d="M56 182.883l-.583-4.083c-.117-.7-.7-1.167-1.284-1.167-.35 0-.7.117-.933.467l-2.8 2.917-.233.233c-.467.583-.35 1.517.35 1.983l.35.234h.116C50.4 184.75 49 185.683 47.6 186.15v-7c1.867-.817 3.267-2.683 3.267-4.9-.117-2.917-2.45-5.25-5.367-5.25a5.228 5.228 0 00-5.25 5.25c0 2.217 1.4 4.083 3.267 4.9v7.117c-1.4-.467-2.684-1.4-3.384-2.684h.117c.117 0 .233-.116.35-.233.35-.233.467-.583.583-.933 0-.35 0-.817-.233-1.05-.117-.117-.117-.234-.233-.234l-2.8-3.033c-.234-.35-.584-.467-.934-.467-.7 0-1.166.467-1.4 1.167L35 182.883v.35c0 .817.583 1.4 1.4 1.4.117 0 .35 0 .467-.116h.116C38.267 187.783 41.767 190 45.5 190c3.733 0 7.233-2.217 8.517-5.483h.116c.117 0 .234.116.467.116.817 0 1.4-.7 1.4-1.4v-.35zm-10.5-11.316a2.59 2.59 0 012.567 2.566A2.59 2.59 0 0145.5 176.7a2.59 2.59 0 01-2.567-2.567c-.116-1.283 1.167-2.566 2.567-2.566z" />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default AnchorIcon;



// WEBPACK FOOTER //
// ./src/components/modules/Examples/AnchorIcon.js